import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EventDotWithText } from './eventDotWithText';

export const EventCalendarInfoDots = () => {
  const { t } = useTranslation();
  return (
    <Grid item xs={12} display='flex' flexDirection='row' justifyContent='end' mr={2} mt={1} mb={1}>
      <EventDotWithText dotColor='success' text={t('event:registered')} />
      <EventDotWithText dotColor='info' text={t('event:isFullyBooked')} />
      <EventDotWithText dotColor='warning' text={t('event:lastApplicationHasPast')} />
    </Grid>
  );
};
